export type Gap =
  | '0'
  | '0.5'
  | '1'
  | '1.5'
  | '2'
  | '2.5'
  | '3'
  | '3.5'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12'
  | '14'
  | '16'
  | '20'
  | '24'
  | '28'
  | '32'
  | '36'
  | '40'
  | '44'
  | '48'
  | '52'
  | '56'
  | '60'
  | '64'
  | '72'
  | '80'
  | '96';

export const cssToClasses = {
  alignItems: {
    'flex-start': 'items-start',
    'flex-end': 'items-end',
    center: 'items-center',
    baseline: 'items-baseline',
    stretch: 'items-stretch',
  },

  justifyContent: {
    normal: 'justify-normal',
    'flex-start': 'justify-start',
    'flex-end': 'justify-end',
    center: 'justify-center',
    'space-between': 'justify-between',
    'space-around': 'justify-around',
    'space-evenly': 'justify-evenly',
    stretch: 'justify-stretch',
  },

  flexWrap: {
    wrap: 'flex-wrap',
    'wrap-reverse': 'flex-wrap-reverse',
    nowrap: 'flex-nowrap',
  },

  position: {
    static: 'static',
    fixed: 'fixed',
    absolute: 'absolute',
    relative: 'relative',
    sticky: 'sticky',
  },

  gap: {
    '0': 'gap-0',
    '0.5': 'gap-0.5',
    '1': 'gap-1',
    '1.5': 'gap-1.5',
    '2': 'gap-2',
    '2.5': 'gap-2.5',
    '3': 'gap-3',
    '3.5': 'gap-3.5',
    '4': 'gap-4',
    '5': 'gap-5',
    '6': 'gap-6',
    '7': 'gap-7',
    '8': 'gap-8',
    '9': 'gap-9',
    '10': 'gap-10',
    '11': 'gap-11',
    '12': 'gap-12',
    '14': 'gap-14',
    '16': 'gap-16',
    '20': 'gap-20',
    '24': 'gap-24',
    '28': 'gap-28',
    '32': 'gap-32',
    '36': 'gap-36',
    '40': 'gap-40',
    '44': 'gap-44',
    '48': 'gap-48',
    '52': 'gap-52',
    '56': 'gap-56',
    '60': 'gap-60',
    '64': 'gap-64',
    '72': 'gap-72',
    '80': 'gap-80',
    '96': 'gap-96',
  },
};
